var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    [
      _c(
        "el-aside",
        { class: { collapse: _vm.collapse }, attrs: { width: "280px" } },
        [_c("SideMenu")],
        1
      ),
      _c(
        "el-container",
        { staticClass: "app-wrapper" },
        [
          _c("el-header", [_c("Header")], 1),
          _c(
            "el-main",
            [
              _c(
                "el-scrollbar",
                { ref: "scrollbar", staticClass: "custom app" },
                [
                  _c(
                    "keep-alive",
                    { attrs: { exclude: _vm.exclude } },
                    [
                      _c("router-view", {
                        key: _vm.path,
                        staticClass: "container",
                      }),
                    ],
                    1
                  ),
                  _c("el-backtop", {
                    attrs: {
                      target: ".el-scrollbar .el-scrollbar__wrap",
                      "visibility-height": 100,
                      bottom: 60,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }